import React from 'react'; // eslint-disable-line no-unused-vars
import styled from 'react-emotion';

const StyledMenu = styled('div')`
  padding: 10px 8px;
  position: absolute;
  z-index: 1;
  top: ${props => props.above ? null : '40px'};
  bottom: ${props => props.above ? '40px' : null};
  margin: 10px 0;
  opacity: 1;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 100px;
  transition: opacity 0.75s;
  cursor: pointer;
  text-align: center;

  & > * {
    display: inline-block;
  }
  & > * + * {
    margin-top:10px;
  }
`;

export default StyledMenu;
